import { ReactNode } from 'react';

import { Illustration, type IllustrationsList } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type EmptyStateProps = Readonly<{
  icon?: IllustrationsList;
  text?: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}>;

export function EmptyState(props: EmptyStateProps) {
  const { icon, className, text, description, children } = props;

  return (
    <div
      className={cn(
        'flex w-full flex-1 flex-col items-center justify-center rounded-lg bg-ui-primary p-8 shadow-[0px_0px_5px_rgba(23,24,24,0.05),0px_1px_2px_rgba(0,0,0,0.15)]',
        className,
      )}
    >
      {icon && (
        <Illustration
          className="mb-4 h-32.5 w-40"
          component={icon || 'IllustrationNoResults'}
        />
      )}
      {text && (
        <h4
          className={cn('text-center', typographyVariants({ variant: 'h4' }))}
        >
          {text}
        </h4>
      )}
      {description && (
        <p
          className={cn(
            typographyVariants({ variant: 'bodyShort01', color: 'secondary' }),
            'mt-2 text-center',
          )}
        >
          {description}
        </p>
      )}
      {children}
    </div>
  );
}
